import React from "react";
import useInviteContactPopup from "./useInviteContactPopup";
import IconButton from "../../Buttons/IconButton";
import crossIcon from "../../../assets/images/Close.svg";
import Dropdown from "../../Dropdown/Dropdown";
import RadioButton from "../../Buttons/RadioButton";
import Input from "../../Input/Input";
import SaveButton from "../../Buttons/SaveButton";
import DatePicker from "../../DatePicker/DatePicker";
import CancelButton from "../../Buttons/CancelButton";
import UserSeatsWarning from "../../Warning/UserSeatsWarning/UserSeatsWarning";
import UserEmailWarning from "../../Warning/UserEmailWarning/UserEmailWarning";

const InviteContactPopup = ({ popupData, closePopup }) => {
  const {
    roles,
    states,
    directReportOptions,
    invalidForm,
    sendInvite,
    userRole,
    setUserRole,
    isEmployee,
    setIsEmployee,
    stateOfEmployment,
    setStateOfEmployment,
    employeeId,
    setEmployeeId,
    selectedDirectReport,
    setSelectedDirectReport,
    hireDate,
    setHireDate,
    availableSeats,
    emails,
  } = useInviteContactPopup({
    popupData,
    closePopup,
  });

  return (
    <div
      className="flex flex-col shadow-1 bg-white border border-es-light-grey rounded-lg"
      style={{ width: "555px" }}
    >
      <div className="flex flex-col gap-5 p-6 pt-2" style={{ height: "660px" }}>
        {/* Title */}
        <div className="es-dark-grey text-es-normal font-es-bold flex flex-row justify-between pt-4 items-center">
          <p>Invite to EstateSpace</p>
          <IconButton
            icon={crossIcon}
            imgClassName="w-3 h-3"
            onClick={() => closePopup()}
          />
        </div>
        {availableSeats === 0 && <UserSeatsWarning />}
        {emails?.length === 0 && (
          <UserEmailWarning
            closePopup={closePopup}
            setEditingContact={popupData.setEditingContact}
          />
        )}
        {/* Form Container */}
        <div
          className={`flex flex-col border rounded-lg border-es-light-grey p-8 pt-6 gap-6 h-full overflow-y-scroll ${
            isEmployee ? "pr-6" : "pr-8"
          }`}
        >
          {/* Role */}
          <div className="flex flex-col gap-3">
            <p className="text-es-normal text-es-medium-grey font-es-semibold">
              Role
            </p>
            <Dropdown
              className="w-full"
              options={roles}
              value={userRole}
              onChange={(val) => setUserRole(val)}
            />
          </div>
          <div className="w-full border-b" />

          {/* Invite as employee */}
          <div className="flex flex-col gap-3">
            <p className="text-es-normal text-es-medium-grey font-es-semibold">
              Invite as Employee?
            </p>
            <div className="flex flex-row gap-2">
              <RadioButton
                isChecked={isEmployee}
                onChange={() => setIsEmployee(true)}
                label="Yes"
                labelClassName="pl-2 text-es-normal text-es-medium-grey"
              />
              <RadioButton
                isChecked={!isEmployee}
                onChange={() => setIsEmployee(false)}
                label="No"
                labelClassName="pl-2 text-es-normal text-es-medium-grey"
              />
            </div>
          </div>

          {isEmployee && (
            <>
              <div className="w-full border-b" />

              {/* Employee ID */}
              <div className="flex flex-col gap-3">
                <p className="text-es-normal text-es-medium-grey font-es-semibold">
                  Employee ID
                </p>
                <Input
                  className="w-full"
                  value={employeeId}
                  onChange={(val) => setEmployeeId(val)}
                  disabled={!isEmployee}
                />
              </div>

              <div className="w-full border-b" />

              {/* Hire Date */}
              <div className="flex flex-col gap-3">
                <p className="text-es-normal text-es-medium-grey font-es-semibold">
                  Hire Date
                </p>
                <DatePicker
                  className="w-full"
                  value={hireDate}
                  onChange={(val) => setHireDate(val)}
                  disabled={!isEmployee}
                />
              </div>
            </>
          )}

          <div className="w-full border-b" />

          {/* State of Employment */}
          <div className="flex flex-col gap-3">
            <p className="text-es-normal text-es-medium-grey font-es-semibold">
              State of Employment
            </p>
            <Dropdown
              className="w-full"
              options={states}
              value={stateOfEmployment}
              onChange={(val) => setStateOfEmployment(val)}
            />
          </div>

          <div className="w-full border-b" />

          {/* Select Direct Report */}
          <div className="flex flex-col gap-3">
            <p className="text-es-normal text-es-medium-grey font-es-semibold">
              Select Direct Report
            </p>
            <Dropdown
              className="w-full"
              options={directReportOptions}
              value={selectedDirectReport}
              onChange={(val) => setSelectedDirectReport(val)}
              menuPlacement="top"
            />
          </div>
        </div>
        <div className="flex flex-row items-center justify-start gap-3">
          <SaveButton
            saveButtonTitle="Send Invite"
            onClick={() => sendInvite()}
            disabled={emails?.length === 0 || invalidForm || !availableSeats}
            style={{ height: "52px", width: "151px" }}
            className="flex flex-row items-center justify-center rounded-lg"
          />
          <CancelButton
            onClick={() => closePopup()}
            style={{ height: "52px" }}
            className="flex flex-row items-center justify-center rounded-lg"
          />
        </div>
      </div>
    </div>
  );
};

export default InviteContactPopup;
